export default __webpack_public_path__ + "static/media/dino_showroom_280rxt_kori.ddf64a5e.jpg";